var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-images" },
    [
      _vm._l(_vm.imageList, function (file, index) {
        return [
          _vm.show && !_vm.src
            ? _c("div", { staticClass: "operation top right" }, [
                _c(
                  "div",
                  {
                    staticClass: "el-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return (function (e) {
                          return _vm.onFull(file, index, e)
                        })($event)
                      },
                    },
                  },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "放大", placement: "top" } },
                      [
                        _c("div", { staticClass: "el-icon-full-screen" }, [
                          _c("div", { staticClass: "el-icon-plus" }),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "el-button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return (function (e) {
                          return _vm.onDownload(file, index, e)
                        })($event)
                      },
                    },
                  },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "下载", placement: "top" } },
                      [_c("div", { staticClass: "el-icon-download" })]
                    ),
                  ],
                  1
                ),
                _vm.canDelete
                  ? _c(
                      "div",
                      {
                        staticClass: "el-button",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return (function (e) {
                              return _vm.onRemove(file, e)
                            })($event)
                          },
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "删除", placement: "top" } },
                          [_c("div", { staticClass: "el-icon-delete" })]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.show
            ? _c(
                "el-image",
                _vm._b(
                  {
                    key: index,
                    ref: "wl-images",
                    refInFor: true,
                    attrs: { src: _vm._f("imgSrc")(file), fit: _vm.fit },
                    on: {
                      load: function (e) {
                        return _vm.load(file, e)
                      },
                      error: function (e) {
                        return _vm.error(file, e)
                      },
                      click: function (e) {
                        return _vm.onclick(file, index, e)
                      },
                    },
                  },
                  "el-image",
                  Object.assign({}, _vm.imageSrcList),
                  false
                )
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }